module.exports = __webpack_public_path__ + "img/pencil_01.92bd037e.png";